import React from 'react';

const ShareIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-share" />
    </div>
  );
};

export default ShareIcon;
